import ApiService from '@/common/api.service'
import AclService from '@/common/acl.service'

export default {
  state: {
    activeTerm: null,
  },
  mutations: {
    setActiveTerm(state, data) {
      state.activeTerm = data.term
    },
  },
  actions: {
    getActiveTerm({ commit, state }) {
      return new Promise(resolve => {
        if (state.activeTerm) return resolve(state.activeTerm)
        ApiService.query('sms/stages-statuses')
          .then(({ data }) => {
            AclService.setStages(data.enabled_stages)
            commit('setActiveTerm', data)
            resolve(data.term)
          })
          .catch(err => {
            resolve(null)
            console.log(err)
          })
      })
    },
  },
}
